import { handleResponse } from "./service-helpers";

const NBH_MEMBERS_BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/members`;

export type MemberRetainedStatus = "ACTIVE_MEMBER" | "PASSIVE_MEMBER";

export type ResignationPointsTarget = "SOCIAL_ACCOUNT" | "MEMBER" | "LAPSE";

export interface MemberRetainedDataMember {
    id: string;
    memberNo: number;
    firstName: string;
    lastName: string;
    membershipStart: string;
    membershipEnd: string;
    memberStatus: MemberRetainedStatus;
    currentNotes: string | null;
}

export interface MemberRetainedDataTargetMember {
    id: string;
    memberNo: number;
    firstName: string;
    lastName: string;
    resigned: boolean;
}

export interface MemberRetainedDataResignation {
    reasonName: string | null;
    pointsTarget: ResignationPointsTarget | null;
    pointsTargetMember: MemberRetainedDataTargetMember | null;
    pointsSettledAt: string | null;
    recordedByName: string | null;
}

export interface MemberRetainedDataAddress {
    street: string;
    houseNumber: string | null;
    postcode: string;
    city: string;
}

export interface MemberRetainedDataCleanup {
    cleanedAt: string;
}

export interface MemberRetainedData {
    member: MemberRetainedDataMember;
    resignation: MemberRetainedDataResignation;
    address: MemberRetainedDataAddress | null;
    cleanup: MemberRetainedDataCleanup | null;
}

export async function getMemberRetainedData(token: string, memberId: string): Promise<MemberRetainedData> {
    const response = await fetch(`${NBH_MEMBERS_BASE_URL}/${memberId}/retained-data`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });

    return await handleResponse<MemberRetainedData>(response) as MemberRetainedData;
}
